import {
  ApolloClient,
  InMemoryCache,
  // createHttpLink,
  from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

import { createUploadLink } from 'apollo-upload-client'

const getEndpoint = () => {
  const url = process.env.REACT_APP_GRAPHQL_URL
  let path
  if (!url) {
    console.error('REACT_APP_GRAPHQL_URL env variable not set.')
  }
  if (process.env.REACT_APP_SECURE_SERVER === 'false') {
    path = `http://${url}`
  } else {
    path = `https://${url}`
  }
  return path
}

const getFreshToken = async refreshToken => {
  const data = await fetch(getEndpoint(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query: `
            mutation getNewRefreshToken($refreshToken: String!){
              refreshToken(refreshToken: $refreshToken){
                token
                payload
              }
            }
        `,
      variables: { refreshToken: refreshToken },
    }),
  })
    .then(res => res.json())
    .then(res => {
      localStorage.setItem('token', res.data.refreshToken.token)
      localStorage.setItem('tokenExp', res.data.refreshToken.payload.exp)
      return res.data.refreshToken.token
    })
  return data
}

const getToken = async () => {
  const refreshExp = parseInt(localStorage.getItem('refreshExp'))
  const refreshToken = localStorage.getItem('refreshToken')
  const token = localStorage.getItem('token')
  const tokenExp = parseInt(localStorage.getItem('tokenExp'))
  const now = Math.ceil(Date.now() / 1000)

  if (!refreshToken || now > refreshExp) {
    if (localStorage.getItem('refreshToken') !== null) {
      console.debug('Removing all local token keys.')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('refreshExp')
      localStorage.removeItem('token')
      localStorage.removeItem('tokenExp')
    }
    return ''
  } else {
    let seconds = Math.floor(refreshExp - now)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)
    let days = Math.floor(hours / 24)
    hours = hours - days * 24
    minutes = minutes - days * 24 * 60 - hours * 60
    seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60
    console.debug(
      `Login valid till ${days}days ${hours}hours ${minutes}mins ${seconds}secs`
    )
  }

  if (!token || now > tokenExp) {
    const newToken = await getFreshToken(refreshToken)
    return newToken
  } else {
    console.debug(`Token valid till ${tokenExp - now}sec`)
    return token
  }
}

const authLink = setContext(async (_, { headers }) => {
  const token = await getToken()
  const header = `JWT ${token}`
  if (token) {
    return {
      headers: {
        ...headers,
        authorization: header,
      },
    }
  } else {
    return {
      headers: {
        ...headers,
      },
    }
  }
})

const errorLink = onError(props => {
  const { graphQLErrors, networkError } = props
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(`[GraphQL error]: Message: ${message}, Path: ${path}`)
    )
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

const uploadLink = createUploadLink({
  uri: getEndpoint(),
})

const client = new ApolloClient({
  link: from([authLink, errorLink, uploadLink]),
  cache: new InMemoryCache(),
})

export default client
